window.addEventListener("scroll", function(){
    let fixedHeader = this.document.getElementById("js-fixedHeader");
    // ウィンドウの高さ
    let heroHeight = this.window.innerHeight;
    // スクロール位置
    let scrollPosition = this.window.scrollY;

    if(scrollPosition > heroHeight){
        fixedHeader.style.display = "flex";
    } else{
        fixedHeader.style.display = "none";
    }
})



